<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content" style="padding-top: 3em">
      <v-row>
        <v-col cols="12" md="10" offset-md="1">
          <v-card elevation="0">
            <v-card-title class="font-weight-thin text-h4 justify-center">
              <v-icon large> mdi-domain </v-icon> Editer ma page entreprise
            </v-card-title>
            <v-card-subtitle>
              <v-row align="center" justify="space-around" class="mt-10">
                <v-btn depressed to="/company/my-account">
                  <v-icon left> mdi-undo-variant </v-icon>
                  Revenir à mon espace employeur
                </v-btn>
                <v-btn
                  depressed
                  color="primary"
                  :to="`/company/page/${companyInformations.id}`"
                  target="_blank"
                >
                  <v-icon left> mdi-file-eye </v-icon>
                  Consulter ma page employeur
                </v-btn>
              </v-row>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12">
          <AboutCompany />
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import AboutCompany from "@/components/Company/AboutCompany";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "CompanyManageMyPage",
  components: { AboutCompany },
  data: function () {
    return {
      companyInformations: {},
    };
  },
  mounted() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const httpClient = new HttpClient();
    // fetch company informations
    httpClient
      .getMyCompanyInformations(
        this.currentUser.companyManager.id,
        localStorage.getItem("jwt-token")
      )
      .then((res) => {
        this.companyInformations = res.data;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push("/logout");
        } else if (error.response.status === 404) {
          this.$router.push({ name: "not_found" });
        } else {
          alert("Une erreur s'est produite");
        }
      });
  },
});
</script>

<style scoped></style>
